"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapStream = void 0;
const ndjson_1 = require("ndjson");
const unwrapStream = (response, timeout = 5000) => {
    const stream = response.data.pipe((0, ndjson_1.parse)());
    const totalCount = response.headers['x-total-count'] ? parseInt(response.headers['x-total-count']) : null;
    let receivedCount = 0;
    return new Promise((resolve, reject) => {
        const products = [];
        const startTimeOut = () => {
            return setTimeout(() => reject(new Error(`TimeOutError`)), timeout);
        };
        let timeOut = startTimeOut();
        stream
            .on('data', (product) => {
            clearTimeout(timeOut);
            products.push(product);
            timeOut = startTimeOut();
            receivedCount++;
        })
            .on('end', () => {
            clearTimeout(timeOut);
            if (totalCount !== null && totalCount !== receivedCount) {
                reject(new Error(`Did not receive all objects. Expected: ${totalCount}, Received: ${receivedCount}`));
            }
            else {
                resolve(products);
            }
        })
            .on('error', (error) => {
            clearTimeout(timeOut);
            reject(error);
        });
    });
};
exports.unwrapStream = unwrapStream;
